import { get, noop } from 'lodash';

const setGlobalVariable = (variableName, variable) => {
  window[variableName] = variable;
};

// dependencies that must be loaded in framework
export const lazyLoadDependencies = () => {
  import(/* webpackChunkName: "react" */'react')
    .then((m) => setGlobalVariable('React', m.default));
  import(/* webpackChunkName: "react-dom" */'react-dom')
    .then((m) => setGlobalVariable('ReactDom', m.default));
  import(/* webpackChunkName: "react-router-dom" */'react-router-dom')
    .then((m) => setGlobalVariable('ReactRouterDom', m));
  import(/* webpackChunkName: "classnames" */'classnames')
    .then((m) => setGlobalVariable('classnames', m.default));
  import(/* webpackChunkName: "app-context" */'../app-context')
    .then((m) => setGlobalVariable('AppContext', m.default));
  import(/* webpackChunkName: "json-form-context" */'../json-form-context')
    .then((m) => setGlobalVariable('JsonFormContext', m.default));
  import(/* webpackChunkName: "page-context" */'../contexts/page-context')
    .then((m) => setGlobalVariable('PageContext', m.default));
  import(/* webpackChunkName: "site-context" */'../contexts/site-context')
    .then((m) => setGlobalVariable('SiteContext', m.default));
  import(/* webpackChunkName: "file-uploader" */'../components/form-widget/file-uploader')
    .then((m) => setGlobalVariable('FileUploader', m));
};

const widgetDependencies = {
  RegeneratorRuntime: async () => import(/* webpackChunkName: "RegeneratorRuntime" */ 'regenerator-runtime')
    .then((m) => setGlobalVariable('RegeneratorRuntime', m.default)),
  historyApi: async () => import(/* webpackChunkName: "history" */ 'history')
    .then((m) => setGlobalVariable('historyApi', m)),
  Lodash: async () => import(/* webpackChunkName: "lodash" */'lodash')
    .then((m) => setGlobalVariable('Lodash', m)),
  MaterialCore: async () => import(/* webpackChunkName: "material-ui-core" */'@material-ui/core')
    .then((m) => setGlobalVariable('MaterialCore', m)),
  MaterialLab: async () => import(/* webpackChunkName: "material-ui-lab" */'@material-ui/lab')
    .then((m) => setGlobalVariable('MaterialLab', m)),
  MaterialPickers: async () => import(/* webpackChunkName: "material-ui-pickers" */'@material-ui/pickers')
    .then((m) => setGlobalVariable('MaterialPickers', m)),
  ReactJsonschemaForm: async () => import(/* webpackChunkName: "react-jsonschema-form" */'react-jsonschema-form')
    .then((m) => setGlobalVariable('ReactJsonschemaForm', m)),
  RjsfMaterialUi: async () => import(/* webpackChunkName: "rjsf-material-ui" */'rjsf-material-ui')
    .then((m) => setGlobalVariable('RjsfMaterialUi', m)),
  cryptoJs: async () => import(/* webpackChunkName: "crypto-js" */'crypto-js')
    .then((m) => setGlobalVariable('cryptoJs', m.default)),
  Graphiql: async () => import(/* webpackChunkName: "graphiql" */'graphiql')
    .then((m) => setGlobalVariable('Graphiql', m.default)),
  Graphql: async () => import(/* webpackChunkName: "graphql" */'graphql')
    .then((m) => setGlobalVariable('Graphql', m)),
  GraphqlTag: async () => import(/* webpackChunkName: "graphql-tag" */'graphql-tag')
    .then((m) => setGlobalVariable('GraphqlTag', m.default)),
  Moment: async () => import(/* webpackChunkName: "moment" */'moment')
    .then((m) => setGlobalVariable('Moment', m.default)),
  MomentUtils: async () => import(/* webpackChunkName: "date-io-Moment" */'@date-io/moment')
    .then((m) => setGlobalVariable('MomentUtils', m.default)),
  immer: async () => import(/* webpackChunkName: "immer" */'immer')
    .then((m) => setGlobalVariable('immer', m)),
  xlsx: async () => import(/* webpackChunkName: "xlsx" */'xlsx')
    .then((m) => setGlobalVariable('xlsx', m.default)),
  reactSwipeableViews: async () => import(/* webpackChunkName: "react-swipeable-views" */'react-swipeable-views')
    .then((m) => setGlobalVariable('reactSwipeableViews', m.default)),
  Graphql2JsonSchema: async () => import(/* webpackChunkName: "graphql-2-json-schema" */'graphql-2-json-schema')
    .then((m) => setGlobalVariable('Graphql2JsonSchema', m)),
  Semver: async () => import(/* webpackChunkName: "semver" */'semver')
    .then((m) => setGlobalVariable('Semver', m.default)),
  RmcPicker: async () => import(/* webpackChunkName: "rmc-picker" */'rmc-picker')
    .then((m) => setGlobalVariable('RmcPicker', m)),
  Panzoom: async () => import(/* webpackChunkName: "panzoom" */'panzoom')
    .then((m) => setGlobalVariable('Panzoom', m.default)),
  Nomnoml: async () => import(/* webpackChunkName: "nomnoml" */'nomnoml')
    .then((m) => setGlobalVariable('Nomnoml', m.default)),
  AwsAppSync: async () => import(/* webpackChunkName: "aws-appsync" */'aws-appsync')
    .then((m) => setGlobalVariable('AwsAppSync', m)),
  notistack: async () => import(/* webpackChunkName: "notistack" */'notistack')
    .then((m) => setGlobalVariable('notistack', m)),
  ajv: async () => import(/* webpackChunkName: "ajv" */'ajv')
    .then((m) => setGlobalVariable('ajv', m)),
  htmlToReact: async () => import(/* webpackChunkName: "html-to-react" */'html-to-react')
    .then((m) => setGlobalVariable('htmlToReact', m)),
  Jsoneditor: async () => import(/* webpackChunkName: "json-editor" */'jsoneditor')
    .then((m) => setGlobalVariable('Jsoneditor', m)),
};

export default async function applyGlobalExports(dependencies = []) {
  return Promise.all(
    dependencies.map(
      (dependency) => get(widgetDependencies, dependency, noop)(),
    ),
  );
}
